module.exports = __webpack_public_path__ + "static/825154864.356c902e.jpg";